export type Currency = string;

export const DEFAULT_CURRENCY_CODE: Currency = 'ISK';
